import { render, staticRenderFns } from "./ToxicHabitInfoItem.vue?vue&type=template&id=38393119&"
import script from "./ToxicHabitInfoItem.vue?vue&type=script&lang=js&"
export * from "./ToxicHabitInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports